import React, { Fragment } from 'react'
import Sidebar from '../Components/Sidebar'
import HeaderDesignCreationBlueJacket from '../Components/DesignCreationBlueJacket/HeaderDesignCreationBlueJacket'
import ShirtTwoSvg from '../Components/DesignCreationBlueJacket/ShirtTwoSvg'

function DesignCreationBlueJacket() {
    return (
        <Fragment>
            <div class="container-fluid">
                <div className='row'>
                    <div className='col-sm-3 sidebarss'>
                        <Sidebar />
                    </div>
                    <div className='col-sm-9 ssidebar'>
                        {/* <HeaderDesignCreationPlainJacket />
                        <Shirts /> */}
                        <HeaderDesignCreationBlueJacket />
                        <ShirtTwoSvg />
                        {/* <Shirtt */}
                        {/* < /> */}
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default DesignCreationBlueJacket